export enum ContragentType {
	bankEquer = 1,
	merchantTCP = 2,
	serviceCenter = 3,
	selfCompany = 4
}
